import {useQuery} from '@apollo/react-hooks';

import type {
    GetAccountsSearchResults as GetAccountsSearchResultsQuery,
    GetAccountsSearchResultsVariables as GetAccountsSearchResultsQueryVariables,
} from 'nutshell-graphql-types';

import GET_ACCOUNTS_SEARCH_RESULTS from '../queries/get-accounts-search-results.graphql';

export const useGetAccounts = (
    query?: string | null
): {
    isLoading: boolean;
    accounts: any[];
    refetch: () => Promise<any>;
    fetchMore: (searchTerm?: string | null | undefined) => Promise<any>;
} => {
    const {data, loading, refetch, fetchMore} = useQuery<
        GetAccountsSearchResultsQuery,
        GetAccountsSearchResultsQueryVariables
    >(GET_ACCOUNTS_SEARCH_RESULTS, {
        fetchPolicy: 'cache-and-network',
        variables: {
            query,
            limit: 20,
        },
        notifyOnNetworkStatusChange: true,
    });

    const search = data ? data.search : null;
    const quickResults = search ? search.quickResults : null;

    const accountResults = quickResults ? quickResults.accountResults : [];

    return {
        accounts: accountResults,
        isLoading: loading,
        refetch,
        fetchMore: (searchTerm?: string | null) => {
            return fetchMore({
                query: GET_ACCOUNTS_SEARCH_RESULTS,
                variables: {
                    query: searchTerm,
                    limit: 20,
                },
                // @ts-expect-error
                updateQuery: (previousResult, {fetchMoreResult}) => {
                    if (!fetchMoreResult || !previousResult) return;

                    return {
                        search: {
                            __typename: 'SearchResultItemConnection',
                            ...fetchMoreResult.search,
                        },
                    };
                },
            });
        },
    };
};
